
      // this file is automatically generated by git.version.ts script
      export const versions = {
        version: '0.0.0',
        revision: 'c0f9d10',
        branch: 'dev-backoffice'
      };